export default __webpack_public_path__ + "static/media/hyojae_intro_figure.35c373bc.png";